import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class MultiSelectField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    noResultsText: PropTypes.string,
    removeSelected: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    })),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      })),
    ]).isRequired,
    optionalClass: PropTypes.string,
    filterOptions: PropTypes.func,
    optionRenderer: PropTypes.func,
  };

  static defaultProps = {
    placeholder: '',
    options: [],
  };

  handleChange = (value) => {
    this.props.onChange(value);
  };

  render() {
    const { value, name, placeholder, options, noResultsText, removeSelected,
      filterOptions, optionalClass, optionRenderer } = this.props;

    return (
      <Select
        multi
        name={name}
        value={value}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        className={"form__form-group-select " + optionalClass}
        closeOnSelect={false}
        removeSelected={removeSelected}
        placeholder={placeholder}
        noResultsText={noResultsText}
        filterOptions={filterOptions}
        optionRenderer={optionRenderer}
      />
    );
  }
}

const renderMultiSelectField = props => (
  <div className="form__form-group-input-wrap">
    <MultiSelectField
      {...props.input}
      options={props.options}
      placeholder={props.placeholder}
      noResultsText={props.noResultsText}
      removeSelected={props.removeSelected}
      optionalClass={props.optionalClass}
      filterOptions={props.filterOptions}
      optionRenderer={props.optionRenderer}
    />
    {props.meta.touched && props.meta.error && <span className="form__form-group-error">{props.meta.error}</span>}
  </div>
);

renderMultiSelectField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
};

renderMultiSelectField.defaultProps = {
  meta: null,
  options: [],
  removeSelected: false,
};

export default renderMultiSelectField;

